// extracted by mini-css-extract-plugin
export var grid = "_31-0";
export var span1 = "_31-2";
export var span10 = "_31-b";
export var span10L = "_31-z";
export var span10M = "_31-n";
export var span10Xl = "_31-1b";
export var span11 = "_31-c";
export var span11L = "_31-10";
export var span11M = "_31-o";
export var span11Xl = "_31-1c";
export var span12 = "_31-d";
export var span12L = "_31-11";
export var span12M = "_31-p";
export var span12Xl = "_31-1d";
export var span1L = "_31-q";
export var span1M = "_31-e";
export var span1Xl = "_31-12";
export var span2 = "_31-3";
export var span2L = "_31-r";
export var span2M = "_31-f";
export var span2Xl = "_31-13";
export var span3 = "_31-4";
export var span3L = "_31-s";
export var span3M = "_31-g";
export var span3Xl = "_31-14";
export var span4 = "_31-5";
export var span4L = "_31-t";
export var span4M = "_31-h";
export var span4Xl = "_31-15";
export var span5 = "_31-6";
export var span5L = "_31-u";
export var span5M = "_31-i";
export var span5Xl = "_31-16";
export var span6 = "_31-7";
export var span6L = "_31-v";
export var span6M = "_31-j";
export var span6Xl = "_31-17";
export var span7 = "_31-8";
export var span7L = "_31-w";
export var span7M = "_31-k";
export var span7Xl = "_31-18";
export var span8 = "_31-9";
export var span8L = "_31-x";
export var span8M = "_31-l";
export var span8Xl = "_31-19";
export var span9 = "_31-a";
export var span9L = "_31-y";
export var span9M = "_31-m";
export var span9Xl = "_31-1a";
export var stretch = "_31-1";